(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
window.StikkmaDeliveryMath=(()=>{
// C-EDD public settings parser and independently checked calendar adapter.
// Rules verified against the current C-EDD public shop script and visible widget.
function parseCedSettings(html){
  const marker='Object.assign(window.deliveryED.setting,';
  const found=html.indexOf(marker);if(found<0)throw Error('C-EDD settings not present');
  const start=html.indexOf('{',found+marker.length);let depth=0,quoted=false,escaped=false;
  for(let i=start;i<html.length&&i-start<250000;i++){
    const c=html[i];if(quoted){if(escaped)escaped=false;else if(c==='\\')escaped=true;else if(c==='"')quoted=false;continue;}
    if(c==='"'){quoted=true;continue;}if(c==='{')depth++;else if(c==='}'&&--depth===0){const data=JSON.parse(html.slice(start,i+1));if(!data.delivery__app_setting?.main_delivery_setting)throw Error('Invalid C-EDD settings');return data;}
  }
  throw Error('Unterminated C-EDD settings');
}
const iso=d=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const at=(d,n)=>new Date(d.valueOf()+n*86400000);
function countBusinessOffset(number,offDays,start,holidays){
  if(offDays.length===7)return 0;
  let days=number;
  if(days===0){for(let i=0;i<=6;i++){const d=at(start,i);if(!offDays.includes(d.getDay())&&!holidays.includes(iso(d)))break;days++;}return days;}
  for(let i=1;i<=days&&days<=1000;i++){const d=at(start,i);if(offDays.includes(d.getDay())||holidays.includes(iso(d)))days++;}
  return days;
}
function forecastCed(data,now=new Date()){
  const global=data.delivery__app_setting.main_delivery_setting;
  const product=data.delivery__pro_setting?.product_delivery_setting;
  const categories=data.delivery__cate_setting?.category_delivery_setting||{};
  if(['category','country','language'].some(k=>Object.keys(categories[k]||{}).length))throw Error('C-EDD conditional rules need explicit resolution');
  const c=product?.is_add===1?{...global,...product}:global;
  if(c.countdown_cutoff_advanced_enable!==0)throw Error('Advanced daily cutoff not covered by this verified reference');
  const local=Number(c.timezone_mode)===0?new Date(now):new Date(now.valueOf()+now.getTimezoneOffset()*60000+Number(c.timezone)*3600000);
  const holiday=c.holiday||[],cutoff=new Date(local.getFullYear(),local.getMonth(),local.getDate(),Number(c.countdown_cutoff_hour),Number(c.countdown_cutoff_minute),59);
  function range(week,days,method){
    const off=week.flatMap((v,i)=>Number(v)===0?[i]:[]);let after=local.valueOf()>=cutoff.valueOf()?1:0;
    if((off.includes(local.getDay())||(Number(c.countdown_mode)===2&&holiday.includes(iso(local))))&&[0,1].includes(Number(method)))after=1;
    const min=Number(days[0]),max=Number(days[1]),first=countBusinessOffset(min+after,off,local,holiday);
    if(Number(method)===0)return [iso(at(local,first)),iso(at(local,countBusinessOffset(max+after,off,local,holiday)))];
    if(Number(method)===1)return [iso(at(local,first)),iso(at(local,first+(max-min)+after))];
    if(Number(method)===2)return [iso(at(local,min+after)),iso(at(local,max+after))];
    throw Error('Unsupported C-EDD calculation mode');
  }
  return {ordered:iso(local),ready:range(c.order_ready_work_week,c.order_ready_day_range,c.order_ready_calc_method),delivered:range(c.order_delivery_work_week,c.order_delivery_day_range,c.order_delivery_calc_method),provider:'C-EDD: Estimated Delivery Date'};
}

return {forecastCed};})();

})();
